import React, { useState,useEffect } from "react";
import { Link } from "react-router-dom";
import axios from 'axios';

import { useRecoilState } from "recoil";
import { BranchMenus } from "../../components/recoil/atoms/Menus";

import HeaderBranchTitle from "../components/includes/HeaderBranchTitle";
import { LoginAfterCheckLogin } from "../../components/common/Common";

import noticeIcon from "../../img/icon/icon-notice.svg";
import inquiryIcon from "../../img/icon/icon-inquiry.svg";
/* import textBookIcon from "../../img/icon/icon-order.svg"; */
import "../../css/style.css";

//결제관리
const Operating = () => {
  LoginAfterCheckLogin(2);  //로그인 상태 점검\
  const branch_idx = Number(localStorage.getItem('branch_idx'));

  const [varBranchMenus,setBranchMenus] = useRecoilState(BranchMenus);

  const [varOperatingInfo,setOperatingInfo] = useState({});

  //결제 정보 목록
  const GetOperatingInformation = async() => {
    const sendData = {branch_idx:branch_idx};
    console.log(sendData);
    await axios.post(`${process.env.REACT_APP_HOST}/branch_get_operating_information`,sendData).then((res) => {
      const datas = res.data;
      console.log(datas);
      if(datas.retvalue === 1) {
        setOperatingInfo(datas.results[0]);
      }
    });
  }

  //최초실행부
  useEffect(() => {
    console.log(varBranchMenus);
    setBranchMenus({showMenu:true,gotoMain:1});

    GetOperatingInformation();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="vh-content oper-wrap">
      <HeaderBranchTitle varPageTitle={'정보관리'} varBackString={'none'}/>
      <div className="vh-content-body">
        <div className="user-info">
          <div className="user-left">
            <div className="center-name">{varOperatingInfo.bh_company}</div>
          <div className="user-name"><span>{varOperatingInfo.bh_name}</span>님</div>				
          </div>
          <Link to={'/Branch/BranchInfo'}>정보수정</Link>
        </div>
        <div className="mypage-con">
          <div className="center-wrap">
            <div className="con con01">					
              <ul>
                <li><Link to="/Branch/NoticeSet"><img src={noticeIcon} alt="" />공지사항</Link></li>
                <li><Link to="/Branch/InquirySet"><img src={inquiryIcon} alt="" />1:1문의</Link></li>
                {/* <li><Link to="/Branch/TextBookOrder"><img src={textBookIcon} alt="" />교재주문</Link></li> */}
              </ul>
            </div>
            <div className="con con02">					
              <ul>
                <li><Link to="/Branch/Condition/1">이용약관</Link></li>
                <li><Link to="/Branch/Condition/2">개인정보 처리방침</Link></li>
                <li><Link to="/Branch/Condition/3">취소/환불 정책 동의</Link></li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>	
  );
}
export default Operating;